<template>
	<NuxtLayout>
		<TextHeader />

		<section class="blog__ListWrapper container">
			<div class="filtersTopWrapper">
        <h2 v-text="$t('allPosts')"></h2>
        <Filters :data="filtersList" v-model="selectedFilters" @close="getFilters" @item-remove="getFilters" />
      </div>

			<div v-if="data?.count" class="blogsList__Counter">
        <p>{{ $t('blogsAvailable', data.count) }}</p>
      </div>

			<div v-if="data.results?.length" class="blog__List">
				<NuxtLink :to="item.sef" class="blog__ListItem" v-for="item in data.results" :key="item.id">
					<Flare v-if="item.image" :srcset="item.image" size="both" width="550" height="680" crop="fill" :alt="item.image" />
					<h3 v-text="item.title" />
					<time :datetime="item.blog_date" v-text="formatDate(item.blog_date, 'PPP')" />
					<p v-text="item.description" />
				</NuxtLink>
			</div>
			<div v-else>
				<p v-text="$t('noResultsBlogs')" />
			</div>
		</section>
	</NuxtLayout>
</template>

<script setup>
	defineProps({
		page: {},
	});

	const { data, filter } = await usePaginatedData({
		endpoint: 'blog',
		fields: ['blog_date'],
	});
	const { t } = useI18n();
	const { page } = usePage();
	const selectedFilters = ref({});

	const filtersList = [
		{
      title: t('filtersTexts.region'),
      identifier: 'locations',
      items: page?.value?.locations || [],
    },
		{
      title: t('filtersTexts.interests'),
      identifier: 'interests',
      items: page?.value?.interests || [],
    },
	];

	function getFilters() {
    setTimeout(async () => {
      filter(selectedFilters.value);
    }, 0)
  }
</script>

<style lang="scss">
	@import url('@/assets/styles/pages/_blogList.scss');
</style>
